//埋点方法
import CONFIG from "../utils/config.js"
import Util from "../utils/util.js"
import Storage from "../utils/storage.js"
import User from "../api/model/user/index.js"
window.mini_paq = mini_paq || []
var BASE_URL = CONFIG.BASE_URL
if(window.location.hostname.indexOf("takungpao.com")!== -1){//今日大公
    BASE_URL = CONFIG.BASE_EPAPER_URL
}
const initMiniCi= async function (){
    //埋点 初始化
    //页面加载时初始化
    //设置统计地址
    mini_paq.push(["setTrackerUrl", `${BASE_URL}mini-ci-clean/api/v1/reportData/nm.gif`])
    //物品统计地址
    mini_paq.push(["setTrackerItemUrl", `${BASE_URL}mini-ci-clean/api/v1/reportData/report/item`])
    //设置统计id 后台创建统计渠道时自动生成
    let setTraceId = "1613452419654619136"
    if(window.location.hostname.indexOf("takungpao.com")!== -1){//今日大公1
        setTraceId = "1994319260914159616"
    }
    if(window.location.hostname.indexOf("takungpao.com.hk")!== -1){//今日大公2
        setTraceId = "1994319478904721408"
    }
    mini_paq.push(["setTraceId",setTraceId])
    // _paq.push(["setTraceId", "dotdotnews002"]);
    //设置用户id 未登录为空
    var userId = ""
    //获取用户数据备用
    var accessToken = Storage.getCookie({key:"access_token"})
    if(Util.isNull(accessToken))return
    var res = await User.getUserProfile()
    if(Util.isNull(res))return
    userId = res.data.uuid
    mini_paq.push(["setUserId",userId?userId:""])
}
const miniCiColumnBrowse = function (){
    var {column} = globalData
    var parentColumns = column.parentColumns
    var parentEndUuid = parentColumns.length?parentColumns[parentColumns.length-1].uuid:""
    var type = "column"
    var uuid = column.dirname
    var columnUrl = window.location.href
    var columnId = column.uuid
    var columnName = column.name
    if(parentEndUuid == "5ee72afae4b0cc64d0f5d568"){
        mini_paq.push(["setTrackerItemUrl", `${BASE_URL}/mini-ci-clean/api/v1/reportData/report/item`])
        type = "special"
        let uuidAdd = ""
        for(let i = parentColumns.length-2;i>=0;i--){
            uuidAdd += `${parentColumns[i].dirname}_`
        }
        uuid = uuidAdd + uuid
        var special = {
            "uuid": uuid,
            "type": type,
            "url": columnUrl,
            "categoryId":columnId,
            "title":columnName
        }
        mini_paq.push(["reportItem", special])
    }else{
        uuid = columnId
    }
    if(column.disabled){
        mini_paq.push(["setTrackerItemUrl", `${BASE_URL}/mini-ci-clean/api/v1/reportData/report/item`])
        let disabledType = "column"
        let disabledUuid = column.uuid
        let disabledParentId = column.parentId || 'tkww'
        let disabledColumn = {
            "uuid": disabledUuid,
            "type": disabledType,
            "url": columnUrl,
            "categoryId":disabledParentId,
            "title":columnName
        }
        mini_paq.push(["reportItem", disabledColumn])
    }
    mini_paq.push(["eventBrowse", uuid,{}])
}
const miniCiContentBrowse = function({story=''}){
    let storyUrl = ""
    if(story===''){
        story = globalData.story
        storyUrl = window.location.href//初次加載走這條
    }else{
        storyUrl = story.url//稿件詳情頁滾動加載走這裡
    }
    // 埋点
    // 稿件浏览
    var storyId = story.id
    var story = {
        "uuid": storyId,
        "type": "story",
        "url": storyUrl
    }
    //方法名，item，
    mini_paq.push(["reportItem", story])
    mini_paq.push(["eventBrowse", storyId,{}])
}
const miniCiSiteBrowse = function (){
    var {site} = globalData
    var columnId = ""
    mini_paq.push(["setTrackerItemUrl", `${BASE_URL}mini-ci-clean/api/v1/reportData/report/column`])
    //管道埋点只埋今日大公
    if(site.dirname=="takungpao"){
        columnId = site.dirname
        var type = "column"
        var special = {
            "uuid": columnId,
            "type": type,
            "url": 'https://www.tkww.hk',
            "categoryId":columnId,
            "title":'今日大公'
        }
        //方法名，item，
        //mini_paq.push(["reportItem", special])
    }
    if(site.dirname=="tkww"){
        columnId = '5ee72ae8e4b0cc64d0f5d567'
    }
    mini_paq.push(["eventBrowse", columnId,{}])
}
const chooseMiniCiBrowse = function (){
    var {site,column,story} = globalData
    if(story!==null)return miniCiContentBrowse({})
    if(column!==null)return miniCiColumnBrowse()
    if(site!==null)return miniCiSiteBrowse()
}
const ciCollect = function(toName,story=""){
    if(story===""){
        story = globalData.story
    }
    var actionExt = {
        "title":story.title,
        "columnId":story.columnId,
    };
    pointStoryShare({story})
    mini_paq.push(["eventShare", story.id, toName, actionExt]);
}

// 新版ui广告埋点方法 adReport(广告位id(Ad+區塊代碼+_排序),稿件鏈接url,稿件源鏈接originUrl,稿件summary)
const adReport1 = function(adSpaceId,linkStoryUrl,adUrl,title,reportEvent="eventBrowse"){
    mini_paq.push(["setTrackerItemUrl", "https://www.tkww.hk/mini-ci-clean/api/v1/reportData/report/item"]);
    var advert = {
        "uuid": adUrl + "tkww",
        "type": "advert",
        "url": adUrl,
        "title":title,
        "categoryId": adSpaceId
    };
    //方法名，item，
    if(reportEvent==="eventBrowse")mini_paq.push(["reportItem", advert]);
    mini_paq.push([reportEvent, "advert" + adUrl + adSpaceId,{}]);
}
//頂部廣告展示
const immediateLook=function (classStr=".page-head .da-box-list-1-unit-v5"){
    let $classStr = $(classStr)
    for(let i = 0;i<$classStr.length;i++){
        let adReport1Str = $(classStr).eq(i).attr("onclick")
        if(typeof adReport1Str !=="undefined" && adReport1Str.indexOf("adReport1")!==-1){
            const regex = /adReport1\((.*?)\)/;
            const match = adReport1Str.match(regex);
            if (match) {
                const params = match[1].split(',').map(param => param.replace(/'/g, ''));
                let adSpaceId = params[0]
                let linkStoryUrl = params[1]
                let adUrl = params[2]
                let title = params[3]
                let reportEvent = "eventShow"
                //console.log("立即展示----",adSpaceId,classStr)
                adReport1(adSpaceId,linkStoryUrl,adUrl,title,reportEvent)
            }
        }
    }
}
//滾動廣告展示
const adBoxListLook=function (){
    let daIsShowList = []//廣告是否出現數組 boolean list
    /*let daPositionList = []//廣告位置數組 {top:0,bottom:0} object list*/
    let $daList = $(".da-box-list-1-unit-v5,.da-box-list-4-unit-v5")
    for(let i = daIsShowList.length;i<$daList.length;i++){
        daIsShowList.push(false)
    }
    let windowHeight = window.innerHeight
    function showScrollDa(){
        let $daList1 = $(".da-box-list-1-unit-v5,.da-box-list-4-unit-v5")
        if($daList.length!=$daList1.length){
            daIsShowList = []
            $daList = $daList1
            for(let i = daIsShowList.length;i<$daList.length;i++){
                daIsShowList.push(false)
            }
        }
        for(let i = 0;i<$daList.length;i++){
            let width = $daList[i].getBoundingClientRect().width
            let height = $daList[i].getBoundingClientRect().height
            let top = $daList[i].getBoundingClientRect().top
            let bottom = $daList[i].getBoundingClientRect().bottom
            let pageHeadHeight = 0//$(".head-bottom")[1]?.getBoundingClientRect().height || $(".page-head")[0].getBoundingClientRect().height || 0
            if(!width||!height)continue;
            let isShow = (top - windowHeight < 0) && ( bottom - pageHeadHeight > 0 )
            let adReport1Str = $daList.eq(i).attr("onclick")
            let isSend = isShow && typeof adReport1Str !=="undefined" && (adReport1Str.indexOf("adReport1")!==-1)
            if(!isShow){
                daIsShowList[i] = false
            }
            if(isSend){
                const regex = /adReport1\((.*?)\)/;
                const match = adReport1Str.match(regex);
                if (match) {
                    const params = match[1].split(',').map(param => param.replace(/'/g, ''));
                    let adSpaceId = params[0]
                    let linkStoryUrl = params[1]
                    let adUrl = params[2]
                    let title = params[3]
                    let reportEvent = "eventShow"
                    if(daIsShowList[i]||adSpaceId.indexOf("Ad9033_")!==-1||adSpaceId.indexOf("Ad9034_")!==-1)continue;//排除掉正在顯示的與導航欄廣告
                    daIsShowList[i] = true
                    //console.log("展示----",adSpaceId)
                    adReport1(adSpaceId,linkStoryUrl,adUrl,title,reportEvent)
                }
            }
        }
    }
    $(window).on("scroll",showScrollDa)
    showScrollDa()
}
let showShareBoxTime = ""
const resetShowShareBoxTime = function(){
    showShareBoxTime = new Date().getTime()
}
const endShowShareBoxTime = function(story="") {
    //$(classStr).parents(".content-main").eq(0).find(".share-weixin-box").hide();
    let closeShareBoxTime = new Date().getTime()
    if(closeShareBoxTime - showShareBoxTime>3*1000){//打開時間大於3秒
        ciCollect('微信',story)
    }
}
export default {
    initMiniCi,
    chooseMiniCiBrowse,
    immediateLook,
    adBoxListLook,
    adReport1
}